import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MovieFilterIcon(props: IconProps) {
    return <Icon {...props} iconKey={"movie_filter"}/>
}
